module.exports = __webpack_public_path__ + "media/images/athletes/1332-a123bea71bcd6ccec18dcfc7abee7d0f.png";